<ng-container>

  <div class="module-item-order-container">

    <!-- SEZIONE 1: Articoli con fornitore già assegnato (un solo fornitore disponibile) -->
    <!-- Vengono mostrati con header colorato del fornitore -->
    <ng-container *ngIf="supplierGroups.length > 0">
      
      <mat-list>
        <ng-container *ngFor="let group of supplierGroups; let lastGroup = last;">
          
          <!-- Mostra l'header del fornitore SOLO se ha almeno un articolo visibile -->
          <ng-container *ngIf="hasVisibleItems(group)">
            
            <!-- Header fornitore -->
            <div class="supplier-header">
              <mat-icon class="supplier-icon">store</mat-icon>
              <div class="supplier-info">
                <span class="supplier-label">{{ 'WorkOrderHandlings.Order.SupplierLabel' | translate }}</span>
                <strong class="supplier-name">{{ group.supplier.ReferenceName }}</strong>
              </div>
            </div>

            <!-- Articoli del fornitore -->
            <div class="articles-section">
              <ng-container *ngFor="let handling of group.handlings">
                <!-- Mostra solo gli articoli che NON hanno selezione multipla fornitori -->
                <ng-container *ngFor="let itemHandling of handling.ItemHandlings">
                  <mat-list-item *ngIf="shouldShowInSupplierHeader(itemHandling)">
                    <mat-icon matListItemIcon>{{ getSourceIcon(handling) }}</mat-icon>
                    <div mat-line><strong>{{ itemHandling.Item?.Code }}</strong> {{ itemHandling.Item?.Name }}</div>
                    <div mat-line>{{ itemHandling.StartQty }} {{ itemHandling.UM?.Symbol }}</div>
                  </mat-list-item>
                </ng-container>
              </ng-container>
            </div>

            <!-- Divider tra fornitori (non dopo l'ultimo) -->
            <mat-divider *ngIf="!lastGroup" class="supplier-divider"></mat-divider>

          </ng-container>

        </ng-container>
      </mat-list>

    </ng-container>

    <!-- CASO: Movimentazioni o ordini non raggruppati (per backwards compatibility) -->
    <ng-container *ngIf="handlings && handlings.length > 0 && supplierGroups.length === 0">
      
      <mat-list>
        <div *ngFor="let handling of handlings; let last = last;">

          <div mat-subheader *ngIf="handling.InternalNotes">{{ handling.InternalNotes }}</div>

          <mat-list-item *ngFor="let itemHandling of handling.ItemHandlings">
            <mat-icon matListItemIcon>{{ getSourceIcon(handling) }}</mat-icon>
            <div mat-line><strong>{{ itemHandling.Item?.Code }}</strong> {{ itemHandling.Item?.Name }}</div>
            <div mat-line>{{ itemHandling.StartQty }} {{ itemHandling.UM?.Symbol }}</div>
          </mat-list-item>

          <mat-divider *ngIf="!last"></mat-divider>

        </div>
      </mat-list>

    </ng-container>

  </div>

</ng-container>


<!-- SEZIONE 2: Articoli con selezione multipla fornitori (più fornitori disponibili) -->
<!-- Vengono mostrati con select per scegliere il fornitore -->
<ng-container *ngIf="this.model">

  <div class="module-item-order-container" *ngIf="model.ItemSuppliers?.length ; else noSupplierTmpl">
    
    <mat-list style="padding-bottom: 20px;">
      <div class="supplier-selection-header">
        <strong>{{ 'WorkOrderHandlings.Order.SelectSupplier' | translate }}</strong>
        <div class="supplier-selection-description">
          {{ 'WorkOrderHandlings.Order.SelectSupplierOptional' | translate }}
        </div>
      </div>

      <mat-list-item style="height: 72px;" *ngFor="let item of model.ItemSuppliers">

        <div mat-line style="display: flex; justify-content: space-between; align-items: center;">
          <span style="white-space: pre-line;">
            <strong>{{ item.ItemCode }}<br></strong> {{ item.ItemName }}
          </span>
          <div>
            <mat-form-field *ngIf="item.Suppliers">
              <mat-select 
                (selectionChange)="onSupplierChange(item, $event.value)" 
                placeholder="Seleziona fornitore" 
                [hideSingleSelectionIndicator]="true">
                <mat-option *ngFor="let supplier of item.Suppliers" [value]="supplier">
                  {{ supplier.ReferenceName }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

      </mat-list-item>

    </mat-list>

  </div>

  <!-- CASO: Nessun fornitore da selezionare (fornitore predefinito) -->
  <ng-template #noSupplierTmpl>
    <div class="default-supplier-message" *ngIf="supplierGroups.length === 0">
      {{ 'WorkOrderHandlings.Order.DefaultSupplierWillBeUsed' | translate }}
    </div>
  </ng-template>
  

</ng-container>
